module.exports = __webpack_public_path__ + "static/goffer-hex-801d39b21adc1992411952fff713ceea.png";